export const NEW_NOTIFICATION_KEY = "newNotification";
export const USER_ID_KEY = "user_id";
export const whiteListedDomains = ["@grata.life"];